import { morphism } from 'morphism'

import ErrorModel from '../../models/Error'

import errorSchema from '../../schemas/error'

/**
 * Transform the request errors into our error models
 * @param {Array} errors
 */
export default (errors = []) => {
  return errors.map(error => {
    return morphism(errorSchema, error, ErrorModel)
  })
}
